import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { GiMuscleUp, GiGymBag, GiTargetPrize } from "react-icons/gi";
import PlaceholderImage from "../common/PlaceholderImage";
import useReducedMotion from "../../hooks/useReducedMotion";
import "./AboutPreview.css";

gsap.registerPlugin(ScrollTrigger);

const FEATURES = [
  { icon: GiGymBag, label: "Modern Equipment" },
  { icon: GiMuscleUp, label: "Coached Training" },
  { icon: GiTargetPrize, label: "Goal-Focused Plans" },
];

export default function AboutPreview() {
  const rootRef = useRef(null);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (reducedMotion) return;
      gsap.from(".about-preview__media-main", {
        scrollTrigger: { trigger: rootRef.current, start: "top 75%" },
        opacity: 0, x: -40, duration: 0.9, ease: "power3.out",
      });
      gsap.from(".about-preview__media-secondary", {
        scrollTrigger: { trigger: rootRef.current, start: "top 65%" },
        opacity: 0, y: 40, duration: 0.9, delay: 0.15, ease: "power3.out",
      });
      gsap.from(".about-preview__text > *", {
        scrollTrigger: { trigger: rootRef.current, start: "top 70%" },
        opacity: 0, y: 24, duration: 0.7, stagger: 0.1, ease: "power3.out",
      });
    }, rootRef);
    return () => ctx.revert();
  }, [reducedMotion]);

  return (
    <section className="about-preview section" ref={rootRef}>
      <div className="container about-preview__grid">
        <div className="about-preview__media">
          <div className="about-preview__media-main">
            {/* <PlaceholderImage tone="1" alt="Firm Fit Factory training floor" ratio="4/5" /> */}
            <img src="/gymimages/gym10.jpg" />
          </div>
          <div className="about-preview__media-secondary">
            {/* <PlaceholderImage tone="3" alt="Coach guiding a member through a lift" ratio="4/3" /> */}
            <img src="/gymimages/gym1.png" />
          </div>
        </div>

        <div className="about-preview__text">
          <span className="eyebrow">About Firm Fit Factory</span>
          <h2>Coimbatore's engine room for real, coached transformation.</h2>
          <p>
            Firm Fit Factory is a modern fitness destination in Peelamedu, Coimbatore, created
            for people who want to become stronger, healthier and more confident. Our motivating
            environment, quality equipment and focused training experience help members stay
            committed to their goals.
          </p>
          <ul className="about-preview__features">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <li key={f.label}>
                  <Icon aria-hidden="true" /> {f.label}
                </li>
              );
            })}
          </ul>
          <Link to="/about" className="btn btn-outline">Discover Our Story</Link>
        </div>
      </div>
    </section>
  );
}
